module.exports = __webpack_public_path__ + "static/media/logo-nick.63ba8f92.png";